import { DSTIRecord } from "../../../../models/DSTI/site-dsti-list.interface";
import styles from "../sitedsti.module.scss";
import { Checkbox } from "primereact/checkbox";
import { Card } from "primereact/card";

interface PpeProps {
  dstiDetails?: DSTIRecord;
}

function Ppe({ dstiDetails }: PpeProps) {
  return (
    <>
      {dstiDetails?.ppe ? (
        <div className={styles["responsive-grid-4"]}>
          {dstiDetails.ppe.options.map(ppeItem => {
            return (
              <div key={ppeItem.id} className={styles["equipment-container"]}>
                <div style={{ position: "relative" }} className={styles["checkbox-container"]}>
                  <img
                    src={ppeItem.photo || "https://ionicframework.com/docs/img/demos/thumbnail.svg"}
                    alt={ppeItem.name}
                    onError={e => {
                      e.currentTarget.src =
                        "https://ionicframework.com/docs/img/demos/card-media.png";
                    }}
                    style={{
                      width: "250px",
                      height: "250px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                  <Checkbox
                    inputId={`ppeItem-${ppeItem.id}`}
                    checked={ppeItem.check}
                    className={styles["checkbox-container-input"]}
                    disabled={true}
                    style={{
                      position: "absolute",
                      top: 2,
                      left: 4,
                    }}
                  />
                </div>
                <p className={"my-0"}>{ppeItem.name}</p>
              </div>
            );
          })}
        </div>
      ) : (
        <Card>
          <h2>No PPE found on DSTI</h2>
        </Card>
      )}
    </>
  );
}

export default Ppe;
